import React from "react";
import { PatientAvailablePhysicians, PatientId, PhysicianId } from "../../messages";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppButton } from "../Generic/AppButton";
import Flex from "../Generic/Flex";
import AutoCompleteDialog from "../AutoCompleteDialog";
import { useAutoCompleteDialog } from "../../hooks/useAutoCompleteDialog";
import { useAutoCompletePhysicians } from "./hooks/useAutoCompletePhysician";
import Question from "../OnboardingSection/Question";

export function PhysicianSelect(props: {
  patientId: PatientId;
  selectedPhysician?: string;
  onSave: () => void;
  onClickAddPhysician: () => void;

  setPatientPhysician: (patientId: PatientId, physicianId: PhysicianId) => Promise<void>;
  getAllPhysicians: (patientId: PatientId) => Promise<PatientAvailablePhysicians>;
}) {
  const { isOpen, query, close, open, setQuery } = useAutoCompleteDialog();
  const { predictions, isLoading, showPredictions, updatePhysician } = useAutoCompletePhysicians({
    patientId: props.patientId,
    query: query,
    getAllPhysicians: props.getAllPhysicians,
    setPatientPhysician: props.setPatientPhysician,
  });

  const handleClickPredication = async (prediction: (typeof predictions)[number]) => {
    updatePhysician(prediction.physicianId, {
      onSuccess: () => {
        props.onSave();
      },
    });
  };

  return (
    <Flex direction="column" gap={8}>
      <Question.Input
        placeholder={props.selectedPhysician ?? translate(STRINGS.SELECT_PHYSICIAN)}
        onClick={open}
        onFocus={open}
      />
      <AutoCompleteDialog
        isLoading={isLoading}
        isOpen={isOpen}
        placeholder={translate(STRINGS.SELECT_PHYSICIAN)}
        showPredictions={showPredictions}
        predictions={predictions}
        onChange={setQuery}
        onRequestClose={close}
        onClickPrediction={handleClickPredication}
        query={query}
      />
      <Flex justifyContent="space-between" gap={4}>
        <AppButton
          isLoading={isLoading}
          style={{ flex: 1 }}
          variant="outline"
          onClick={props.onClickAddPhysician}
        >
          {translate(STRINGS.ADD_PHYSICIAN)}
        </AppButton>
      </Flex>
    </Flex>
  );
}
